import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'rizzui/button';

function AppDropDown({ title, options = [] }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleItemClick = (item) => {
        console.log(`Selected: ${item.label}`);
        setIsOpen(false);
        if (item.onClick) item.onClick(); // Allow optional custom handler
    };

    return (
        <div className="p-0">
            <div className="relative inline-block text-left" ref={dropdownRef}>
                <Button
                    onClick={toggleDropdown}
                    className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 max-w-[120px] sm:max-w-none truncate"
                    variant="outline"
                >
                    <span className="truncate">{title}</span>
                    <svg
                        className={`ml-1 sm:ml-2 h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                        />
                    </svg>
                </Button>

                {isOpen && (
                    <div className="origin-top-right absolute right-0 mt-2 w-40 sm:w-48 rounded-md shadow-lg bg-white ring-1 ring-gray-200 ring-opacity-100 z-10 border border-gray-200">
                        <div className="py-1">
                            {options.map((item, index) => (
                                <button
                                    key={index}
                                    onClick={() => handleItemClick(item)}
                                    className="block w-full text-left px-3 sm:px-4 py-2 text-xs sm:text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150"
                                >
                                    <span className="flex items-center truncate">{item.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AppDropDown;